<template>
  <div class="common-container">
    <div class="nav-banner-btn">
      <div class="content">
        <nav-banner-btn/>
      </div>
    </div>
    <div class="city">
      <div class="content">
        <city/>
      </div>
    </div>
    <div class="advert">
      <div class="content">
        <advert/>
      </div>
    </div>
    <div class="inquiry">
      <div class="content">
        <inquiry-tool/>
      </div>
    </div>
    <div class="serve-joins-order">
      <div class="content">
        <serve-joins-order/>
      </div>
    </div>
    <div class="classify-product">
      <div class="content">
        <classify-product/>
      </div>
    </div>
    <div class="all-win">
      <div class="content">
        <all-win/>
      </div>
    </div>
    <div class="report-sample">
      <div class="content">
        <report-sample/>
      </div>
    </div>
    <div class="news">
      <div class="content">
        <news/>
      </div>
    </div>
    <div class="friendship-link">
      <div class="content">
        <friendship-link/>
      </div>
    </div>
  </div>
</template>

<script>
import InquiryTool from "@/views/inquiry/components/Tool.vue";
import FriendshipLink from "./components/FriendshipLink.vue";
import News from "./components/News.vue";
import City from "./components/City.vue";
import ReportSample from "./components/ReportSample.vue";
import AllWin from "./components/AllWin.vue";
import ServeJoinsOrder from "./components/ServeJoinsOrder.vue";
import NavBannerBtn from "./components/NavBannerBtn.vue";
import ClassifyProduct from "./components/ClassifyProduct.vue";
import Advert from "./components/Advert.vue";

export default {
  name: "Home",
  components: {
    FriendshipLink,
    InquiryTool,
    News,
    City,
    ReportSample,
    AllWin,
    ServeJoinsOrder,
    NavBannerBtn,
    ClassifyProduct,
    Advert
  }
}
</script>

<style scoped lang="scss">
.inquiry, .friendship-link, .news, .city, .report-sample, .all-win, .serve-joins-order, .nav-banner-btn, .classify-product, .advert {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .content {
    width: 1200px;
  }
}

.nav-banner-btn {
  margin-top: 30px;
}

.inquiry, .city, .serve-joins-order, .nav-banner-btn, .classify-product, .advert {
  margin-bottom: 20px;
}

.friendship-link, .news, .report-sample, .all-win {
  background-color: #FFFFFF;
  padding: 65px 0;
}
</style>